import { createFileRoute, Outlet } from "@tanstack/react-router"

import PendingComponent from "@/globalComponents/atoms/PendingComponent"
import ErrorComponent from "@/globalComponents/organisms/ErrorComponent"
import MCALLEN_THEME from "@/utilities/json/McAllenTheme"

export const Route = createFileRoute("/qr/$qrLookupID")({
  head: () => ({
    meta: [
      {
        title: "McAllen Airport",
      },
    ],
  }),
  beforeLoad: async ({ context, params }) => {
    context.setScannedArea({
      qrLookupID: params.qrLookupID,
      theme: MCALLEN_THEME,
    })
    context.setDocumentThemeMode("whiteLabel")
  },
  preload: false,
  pendingComponent: PendingComponent,
  // notFoundComponent: (opts) => <RootNotFound {...opts} />,
  errorComponent: (opts) => (
    <ErrorComponent {...opts} resolution="restartFromWelcome" />
  ),
  component: Outlet,
})
